import { atom } from "recoil";
import { FlinksProps } from "./flinks-props";

export const flinksState = atom<FlinksProps | null>({
  key: "flinksState",
  default: null,
});
